"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodNotAllowed = void 0;
const ApiException_1 = require("./ApiException");
class MethodNotAllowed extends ApiException_1.ApiException {
    constructor(message = 'Method Not Allowed', data) {
        super(message, data);
    }
}
exports.MethodNotAllowed = MethodNotAllowed;
